import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/UnbreakableAiWorkflowsBauplanPage.head';
import { UnbreakableAiWorkflowsBauplanPage } from '@pages/UnbreakableAiWorkflowsBauplanPage';

export const Route = createFileRoute('/unbreakable-ai-workflows-bauplan')({
  component: UnbreakableAiWorkflowsBauplanPage,
  head: () => head,
});
